import React, { useCallback } from 'react';
import { activities } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { graphql } from 'react-apollo';
import { reduxForm } from 'redux-form';
import ActivityPrompt from './ActivityPrompt';

const ActivityPromptForm = reduxForm({
  destroyOnUnmount: false,
  form: 'activityPrompt',
})(ActivityPrompt);

function ActivityPromptContainer(props) {
  const {
    isLoading,
    mutateCreateNote,
    patientId,
    onSubmit: onSubmitProp,
    loadMoreRows,
    ...rest
  } = props;

  const onSubmit = useCallback(
    async ({ note }, _, { reset, submitting }) => {
      if (isLoading || !note || submitting) return;

      alertOnError(
        mutateCreateNote({
          variables: {
            patient_id: patientId,
            text: note,
          },
        }),
      )
        .then(() => {
          reset();
          if (onSubmitProp) {
            onSubmitProp();
          }
        })
        .then(() => {
          return loadMoreRows(true);
        });
    },
    [isLoading, mutateCreateNote, patientId, onSubmitProp, loadMoreRows],
  );

  return <ActivityPromptForm {...rest} onSubmit={onSubmit} />;
}

export default graphql(activities.mutateCreateNote, { name: 'mutateCreateNote' })(
  ActivityPromptContainer,
);
